'use client';

import { ReactNode } from 'react';
import type { DashboardSectionKey } from 'constant/dashboardSections';

import { useDashboardSectionGuard } from 'hooks';

import { Loader } from 'ui';

interface DashboardSectionGateProps {
  section: DashboardSectionKey;
  fallbackRoute?: string;
  children: ReactNode;
}

/**
 * Wraps a route's page content, blocking it (redirect + no render) when the tenant has
 * turned this account-portal section off via sys-modules. See `useDashboardSectionGuard`.
 */
const DashboardSectionGate = ({
  section,
  fallbackRoute,
  children
}: DashboardSectionGateProps) => {
  const { isChecking, isAllowed } = useDashboardSectionGuard(
    section,
    fallbackRoute
  );

  if (isChecking) {
    return <Loader fixed />;
  }

  if (!isAllowed) {
    return null;
  }

  return <>{children}</>;
};

export default DashboardSectionGate;
